import * as React from 'react'

const boardDragScrollState = {
  pageX: 0,
  pageY: 0,
  scrolledElement: undefined as Element,
  shouldActivate: false,
  initialScrollLeft: 0,
  initialScrollTop: 0,
  dragActivate: false
}

let requestX: number
let requestY: number

const moveX = (e: MouseEvent) => {
  const dX = boardDragScrollState.pageX - e.pageX
  if (
    !boardDragScrollState.dragActivate &&
    boardDragScrollState.shouldActivate &&
    Math.abs(dX) > 10
  ) {
    boardDragScrollState.dragActivate = true
    boardDragScrollState.scrolledElement.classList.add('pointer-events-none')
  }
  cancelAnimationFrame(requestX)
  requestX = requestAnimationFrame(() => {
    boardDragScrollState.scrolledElement.scrollLeft =
      boardDragScrollState.initialScrollLeft + dX
  })
}
const moveY = (e: MouseEvent) => {
  const dY = boardDragScrollState.pageY - e.pageY
  if (
    !boardDragScrollState.dragActivate &&
    boardDragScrollState.shouldActivate &&
    Math.abs(dY) > 10
  ) {
    boardDragScrollState.dragActivate = true
    boardDragScrollState.scrolledElement.classList.add('pointer-events-none')
  }
  cancelAnimationFrame(requestY)
  requestY = requestAnimationFrame(() => {
    boardDragScrollState.scrolledElement.scrollTop =
      boardDragScrollState.initialScrollTop + dY
  })
}
const moveXY = (e: MouseEvent) => {
  moveX(e)
  moveY(e)
}
const mouseMoveX = moveX
const mouseMoveY = moveY
const mouseMoveXY = moveXY

const dragStop = () => {
  boardDragScrollState.dragActivate = false
  if (boardDragScrollState.scrolledElement) {
    boardDragScrollState.scrolledElement.classList.remove(
      'grabbing',
      'pointer-events-none'
    )
  }
  document.removeEventListener('mouseup', mouseUp)
  document.removeEventListener('mousemove', mouseMoveX)
  document.removeEventListener('mousemove', mouseMoveY)
  document.removeEventListener('mousemove', mouseMoveXY)
}
const mouseUp = dragStop

type ScrollDirection = 'scroll-x' | 'scroll-y' | 'scroll-xy'

export const useDragScrollable = ({
  direction = 'scroll-x',
  shouldActivate = false
}: {direction?: ScrollDirection; shouldActivate?: boolean} = {}): [
  React.RefObject<HTMLDivElement>,
  (e: React.MouseEvent) => void
] => {
  const ref = React.useRef<HTMLDivElement>(null)
  return [
    ref,
    e => DragScrollable.mouseDown(ref.current, direction, shouldActivate)(e)
  ]
}

export class DragScrollable {
  public static mouseDown =
    (
      el: HTMLElement | Element,
      direction: ScrollDirection = 'scroll-x',
      shouldActivate = false
    ) =>
    (e: React.MouseEvent | MouseEvent) => {
      if (!el || e.button !== 0) {
        return
      }
      boardDragScrollState.shouldActivate = shouldActivate

      // react event is reused, so we can’t modify the event itself
      const nativeEvent = (e as React.MouseEvent).nativeEvent ?? e
      if ('noDragScroll' in nativeEvent || 'consumed' in nativeEvent) {
        return
      }
      ;(nativeEvent as any).noDragScroll = true
      e.stopPropagation()

      boardDragScrollState.scrolledElement = el
      boardDragScrollState.pageX = e.pageX
      boardDragScrollState.pageY = e.pageY
      boardDragScrollState.initialScrollLeft = el.scrollLeft
      boardDragScrollState.initialScrollTop = el.scrollTop

      el.classList.add('grabbing')
      document.addEventListener('mouseup', mouseUp)
      document.addEventListener(
        'mousemove',
        direction === 'scroll-x'
          ? mouseMoveX
          : direction === 'scroll-xy'
          ? mouseMoveXY
          : mouseMoveY
      )
    }
}
